import { EventObject, Typestate } from 'xstate';
import { ApplyResponseEvent } from '../actions/sharedNetworkActions';
import { ApplyRequestEvent } from '../../networkRequests/apply/apply';
import { OrderIdMachineContext } from './shared/context/orderIdMachineContext';
import { OrderMachineContext } from './shared/context/orderMachineContext';
import { ApplyRequestMachineContext, ApplyResponseMachineContext } from './shared/context/applyMachineContext';
import { RoleMachineContext } from './shared/context/roleMachineContext';

// Context Types
export interface NewApplicationMachineContext
  extends RoleMachineContext,
    OrderIdMachineContext,
    OrderMachineContext,
    ApplyRequestMachineContext,
    ApplyResponseMachineContext {
  autoVerticalError?: boolean;
}

// State Types
export enum NewApplicationStates {
  AccommodationAddress = 'AccommodationAddress',
  Decline = 'Decline',
  ExistingApplication = 'ExistingApplication',
  ApplyLoading = 'ApplyLoading',
  LoanDeclined = 'LoanDeclined',
  LeaseDeclined = 'LeaseDeclined',
  LTOIneligible = 'LTOIneligible',
  Ineligible = 'Ineligible',
  Loading = 'AccommodationAddressLoading',
  GeneralError = 'GeneralError',
  AccommodationAddressErrors = 'AccommodationAddressErrors',
  PrequalificationNotice = 'PrequalificationNotice',
}

export interface NewApplicationMachineStatesSchema {
  [NewApplicationStates.AccommodationAddress]: {};
  [NewApplicationStates.Decline]: {};
  [NewApplicationStates.ExistingApplication]: {};
  [NewApplicationStates.LoanDeclined]: {};
  [NewApplicationStates.LeaseDeclined]: {};
  [NewApplicationStates.LTOIneligible]: {};
  [NewApplicationStates.Ineligible]: {};
  [NewApplicationStates.Loading]: {};
  [NewApplicationStates.GeneralError]: {};
  [NewApplicationStates.AccommodationAddressErrors]: {};
  [NewApplicationStates.ApplyLoading]: {};
  [NewApplicationStates.PrequalificationNotice]: {};
}

export interface NewApplicationMachineStates extends Typestate<NewApplicationMachineContext> {
  type: NewApplicationMachineStatesSchema;
}

// Event Types
export enum NewApplicationEvents {
  NEXT = 'NEXT',
  VALIDATION_ERROR = 'ValidationError',
  BACK = 'BACK',
  CUST_LOOKUP = 'CustomerLookup',
  VIEW_PREQUALIFICATION_NOTICE = 'ViewPrequalificationNotice',
  TRACK = 'TRACK',
  PAGE = 'PAGE',
  IDENTIFY = 'IDENTIFY',
}

type NewApplicationEventsTypeSchema =
  | NewApplicationEvents.NEXT
  | NewApplicationEvents.VALIDATION_ERROR
  | NewApplicationEvents.BACK
  | NewApplicationEvents.CUST_LOOKUP
  | NewApplicationEvents.VIEW_PREQUALIFICATION_NOTICE
  | NewApplicationEvents.TRACK
  | NewApplicationEvents.PAGE
  | NewApplicationEvents.IDENTIFY;

export type NewApplicationMachineEvents = NewApplicationMachineEvent | ApplyRequestEvent | ApplyResponseEvent;

export interface NewApplicationMachineEvent extends EventObject {
  type: NewApplicationEventsTypeSchema;
  data?: any;
}

// Guard Types
export enum NewApplicationGuardsType {
  LEASE_DECLINED = 'LeaseDecline',
  LOAN_DECLINED = 'LoanDecline',
  LTO_INELIGIBLE = 'LTOIneligible',
  APP_APPROVED = 'AppApproved',
  GENERAL_APPLY_ERRORS = 'GeneralApplyErrors',
  SOFT_DECLINE = 'SoftDecline',
}
type NewApplicationGuardsTypeSchema =
  | NewApplicationGuardsType.LEASE_DECLINED
  | NewApplicationGuardsType.LOAN_DECLINED
  | NewApplicationGuardsType.LTO_INELIGIBLE
  | NewApplicationGuardsType.GENERAL_APPLY_ERRORS
  | NewApplicationGuardsType.SOFT_DECLINE
  | NewApplicationGuardsType.APP_APPROVED;

export interface NewApplicationMachineGuards extends EventObject {
  type: NewApplicationGuardsTypeSchema;
}
